/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_ImpressumInputs */

const en_landing_footer_impressum = /** @type {(inputs: Landing_Footer_ImpressumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impressum`)
};

const de_landing_footer_impressum = /** @type {(inputs: Landing_Footer_ImpressumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impressum`)
};

const fr_landing_footer_impressum = /** @type {(inputs: Landing_Footer_ImpressumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentions légales`)
};

const es_landing_footer_impressum = /** @type {(inputs: Landing_Footer_ImpressumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso legal`)
};

const it_landing_footer_impressum = /** @type {(inputs: Landing_Footer_ImpressumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note legali`)
};

const nl_landing_footer_impressum = /** @type {(inputs: Landing_Footer_ImpressumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colofon`)
};

const pl_landing_footer_impressum = /** @type {(inputs: Landing_Footer_ImpressumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informacje prawne`)
};

const fi_landing_footer_impressum = /** @type {(inputs: Landing_Footer_ImpressumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sivuston tiedot`)
};

const da_landing_footer_impressum = /** @type {(inputs: Landing_Footer_ImpressumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolofon`)
};

const sv_landing_footer_impressum = /** @type {(inputs: Landing_Footer_ImpressumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om tjänsten`)
};

/**
* | output |
* | --- |
* | "Impressum" |
*
* @param {Landing_Footer_ImpressumInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_footer_impressum = /** @type {((inputs?: Landing_Footer_ImpressumInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_ImpressumInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_footer_impressum(inputs)
	if (locale === "fr") return fr_landing_footer_impressum(inputs)
	if (locale === "es") return es_landing_footer_impressum(inputs)
	if (locale === "it") return it_landing_footer_impressum(inputs)
	if (locale === "nl") return nl_landing_footer_impressum(inputs)
	if (locale === "pl") return pl_landing_footer_impressum(inputs)
	if (locale === "fi") return fi_landing_footer_impressum(inputs)
	if (locale === "da") return da_landing_footer_impressum(inputs)
	if (locale === "sv") return sv_landing_footer_impressum(inputs)
	return en_landing_footer_impressum(inputs)
});